import DriverApplication from '../driver-app/App'

import DriverAppMenus from '../driver-app/pages/menus/Index'

export default {
  path: '/driver-app',
  component: DriverApplication,
  children: [
    { path: '/driver-app/menus', name: 'DriverAppMenus', component: DriverAppMenus, meta: { requiresAuth: false } },
  ]
}
